import React from 'react';
import LoginCard from '../components/Login/main';
import { Header } from '../components/Navigation/Header/main';

const LoginPage = () => {
  return (
    <div className='flex flex-col h-screen overflow-hidden bg-gray-100'>
      <div className='flex items-center justify-center flex-grow p-4'>
        <LoginCard />
      </div>
    </div>
  );
};

export default LoginPage;
